(function () {
  "use strict";

  var config = window.fishkillSubscribe || {};
  var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function getMessageEl(form) {
    return form.querySelector(".newsletter-form__message");
  }

  function setMessage(form, text, state) {
    var messageEl = getMessageEl(form);
    if (!messageEl) {
      return;
    }

    messageEl.textContent = text || "";
    messageEl.classList.remove("is-success", "is-error");
    if (state) {
      messageEl.classList.add(state);
    }
  }

  function isConfigured() {
    return !!(config.companyId && config.listId && config.endpoint && config.revision);
  }

  function isValidEmail(value) {
    return EMAIL_PATTERN.test(value);
  }

  function parseKlaviyoError(payload, fallback) {
    if (payload && payload.errors && payload.errors.length && payload.errors[0].detail) {
      return payload.errors[0].detail;
    }
    return fallback;
  }

  function setBusy(form, isBusy) {
    var button = form.querySelector('button[type="submit"]');
    var emailInput = form.querySelector('input[type="email"]');

    form.classList.toggle("is-busy", isBusy);
    if (button) {
      button.disabled = isBusy;
    }
    if (emailInput) {
      emailInput.disabled = isBusy;
    }
  }

  function buildPayload(email) {
    return {
      data: {
        type: "subscription",
        attributes: {
          custom_source: "Fishkill footer signup form",
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: email,
                subscriptions: {
                  email: {
                    marketing: {
                      consent: "SUBSCRIBED",
                    },
                  },
                },
              },
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: config.listId,
            },
          },
        },
      },
    };
  }

  function subscribe(email) {
    var url = config.endpoint + "?company_id=" + encodeURIComponent(config.companyId);

    return fetch(url, {
      method: "POST",
      headers: {
        revision: config.revision,
        "Content-Type": "application/vnd.api+json",
        Accept: "application/vnd.api+json",
      },
      body: JSON.stringify(buildPayload(email)),
    }).then(function (response) {
      return response
        .json()
        .catch(function () {
          return null;
        })
        .then(function (payload) {
          if (response.status === 202) {
            return { ok: true };
          }

          return {
            ok: false,
            message: parseKlaviyoError(
              payload,
              (config.i18n && config.i18n.genericError) || ""
            ),
          };
        });
    });
  }

  function bindForm(form) {
    form.addEventListener("submit", function (event) {
      event.preventDefault();

      var i18n = config.i18n || {};

      if (!isConfigured()) {
        setMessage(form, i18n.missingConfig || "", "is-error");
        return;
      }

      var emailInput = form.querySelector('input[type="email"]');
      var email = emailInput ? emailInput.value.trim() : "";

      if (!isValidEmail(email)) {
        setMessage(form, i18n.invalidEmail || "", "is-error");
        if (emailInput) {
          emailInput.focus();
        }
        return;
      }

      setBusy(form, true);
      setMessage(form, "", "");

      subscribe(email)
        .then(function (result) {
          if (result.ok) {
            setMessage(form, i18n.success || "", "is-success");
            form.reset();
            return;
          }
          setMessage(form, result.message, "is-error");
        })
        .catch(function () {
          setMessage(form, i18n.genericError || "", "is-error");
        })
        .then(function () {
          setBusy(form, false);
        });
    });
  }

  function init() {
    var forms = document.querySelectorAll("[data-newsletter-form]");
    if (!forms.length) {
      return;
    }

    for (var i = 0; i < forms.length; i++) {
      bindForm(forms[i]);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
